
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import mwx from '../../store/modules/mediumwarex';
import moment from 'moment';
import AddMyAccount from '@/components/user/AddMyAccount.vue';
import userx from '../../store/modules/userx';
import { AccountMinimumData } from '../../store/models.def';

@Component({
	components: {
		AddMyAccount,
	},
})
export default class MyAccountsComponent extends Vue {
	public toAdd: AccountMinimumData | null = null;

	public get supportLvl() {
		return userx.user && userx.user.supportLvl;
	}
	public get potentialAccounts() {
		const myAccountsDic = userx.myAccountsDic;
		if (!myAccountsDic) {
			return mwx.allAccounts;
		}
		return mwx.allAccounts.filter((account) =>
			!myAccountsDic[account.accountId] ? true : false,
		);
	}
	public get myAccounts() {
		return userx.myAccounts.map((account) => {
			const newAccount: any = { ...account };
			newAccount.createdAt = moment(newAccount.createdAt).format('DD/MM/YYYY');
			return newAccount;
		});
	}
	public async onDelete(accountId: string) {
		await userx.removeMyAccount(accountId);
	}
}
